<template>
<div class="timeline-box">
    <div class="timeline-label">Шкала времени</div>
    <ul class="timeline-dots" :style="selectedStyle">
        <li :class="(item.npp==selected)?'slide-active':''" v-for="item in items" :key="item.id">
            <button type="button" role="button" @click="$emit('dateChange', item)">{{ item.text }}</button>
        </li>
    </ul>
</div>
</template>

<script>
export default {
    props: ['selected'],
    computed: {
        items() {
            return this.$store.state.timeline.data
        },
        selectedStyle() {
            return `width: ${ 50 * this.items.length }px; left: calc(${ -50 * (this.selected - 1) - 25 }px + 50%);`
        }
    },
    created() {
        // создаем отступы
        window.myMap.margin.addArea({
            bottom: 0,
            left: '0',
            width: '100%',
            height: '50px'
        });
    }
};
</script>

<style scoped>
.timeline-label {
    text-align: center;
    font-size: smaller;
    margin-top: -10px;
    color: #8a94a1;
}

.timeline-box {
    position: absolute;
    bottom: 10px;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 20px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    padding: 10px;
    overflow: hidden;
    width: calc(100% - 360px);
    left: 330px;
    height: 40px;
    font-family: sans-serif;
}

.timeline-dots {
    background: url(../assets/css/img/timeline-bg.png) bottom repeat-x;
    margin: 0;
    padding: 0;
    position: relative;
    height: 36px;
    transition: left 0.3s linear;
}

.timeline-dots li {
    list-style: none;
    overflow: hidden;
    float: left;
    width: 50px;
    text-align: center;
}

.timeline-dots button {
    background: url(../assets/css/img/date-icon.png) bottom no-repeat;
    padding-bottom: 15px;
    border: none;
    outline: none;
    color: #333;
    font-size: 12px;
}

.timeline-dots li.slide-active button {
    color: #2972ca;
    font-size: 15px;
    padding-bottom: 13px;
    transition: all 0.3s linear;
}
</style>
